import cls from 'classnames';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

export interface IEmptyTabContentProps {
  tab: 'posts' | 'likes' | 'favorites';
  variant: 'empty' | 'private';
}

export const EmptyTab: FC<IEmptyTabContentProps> = (props) => {
  const { t } = useTranslation();
  const { tab, variant } = props;

  const hint = useMemo(() => {
    if (tab === 'posts' && variant === 'private') {
      return t('user_hide_article');
    }
    if (tab === 'posts' && variant === 'empty') {
      return t('no_content');
    }
    if (tab === 'favorites' && variant === 'private') {
      return t('user_no_public_favorite');
    }
    if (tab === 'favorites' && variant === 'empty') {
      return t('user_no_favorite');
    }
    if (tab === 'likes' && variant === 'private') {
      return t('user_no_public_like');
    }
    if (tab === 'likes' && variant === 'empty') {
      return t('user_no_like');
    }

    return '';
  }, [tab, variant]);

  return (
    <div className="user-empty-tab-content">
      <div className={cls('illustration', tab, variant)} />
      <p className="description">{hint}</p>
    </div>
  );
};
